<template>
  <div>
    <table-component
      ref="table"
      :table-div-id="tableDivId"
      :show-filter="false"
      :data="fetchData"
      table-class="table"
    >
      <table-column
        v-if="userType=='funder'"

        :label="$t('invoices.financing_request_date')"
        sort-as="prepayment_date"
      >
        <template slot-scope="row">
          <p>{{ row.pre_payment_request.formattedPrePaymentDate }}</p>
        </template>
      </table-column>
      <table-column
        v-else
        :label="$t('invoices.date')"
        sort-as="invoice_date"
        show="formattedInvoiceDate"
      />
      <table-column
        v-if="userType=='funder'"

        :label="$t('invoices.promised_payment_date')"
        sort-as="promised_date"
      >
        <template slot-scope="row">
          <p>{{ row.pre_payment_request.formattedPromisedPaymentDate }}</p>
        </template>
      </table-column>
      <table-column
        v-else
        :label="$t('invoices.due_date')"
        sort-as="due_date"
        show="formattedDueDate"
      />
      <table-column
        v-if="userType==='super_admin' || userType==='supplier' || userType==='funder'"
        :label="$t('invoices.customer')"
        width="20%"
      >
        <template slot-scope="row">
          <p v-if="row.buyer_stakeholder">
            <span v-if="userType=='supplier' && row.customer.parent_account_id && row.buyer_stakeholder.details.company && row.buyer_stakeholder.details.company.name">
              {{ row.buyer_stakeholder.details.company.name }}
            </span>
            <span v-else-if="userType=='supplier' && row.customer.parent_account_id==null">
              {{ row.buyer_stakeholder.details.user.name }}
            </span>
            <!-- {{row.buyer_stakeholder.details.user.name}} -->
            <span v-else>
              {{ row.buyer_stakeholder.details.company.name }}
            </span>
          </p>
        </template>
      </table-column>

      <table-column
        v-if="userType==='super_admin' || userType==='anchor' || userType==='funder'"
        :label="$t('invoices.supplier')"
      >
        <template slot-scope="row">
          <p v-if="row.supplier_stakeholder">
            <span v-if="row.supplier_stakeholder.details.company && row.supplier_stakeholder.details.company.name">
              {{ row.supplier_stakeholder.details.company.name }}
            </span>
            <!-- {{row.supplier_stakeholder.details.user.name}} -->
          </p>
        </template>
      </table-column>
      <table-column
        v-if="userType!='super_admin'"
        :label="$t('invoices.status')"
        sort-as="status"
      >
        <template v-if="row.overall_status" slot-scope="row">
          <span> {{ $t('invoices.status') }}</span>
          <span v-if="userType=='anchor' && row.overall_status=='SENT'" :class="'inv-status-'+row.overall_status.toLowerCase()">{{ $t('general.received') }}</span>
          <span v-else-if="userType=='anchor' && row.overall_status !='SENT'" :class="'inv-status-'+row.overall_status.toLowerCase()">{{ (row.overall_status != 'PARTIALLY_PAID')? row.overall_status : row.overall_status.replace('_', ' ') }}</span>
          <span v-else-if="userType!='anchor'" :class="'inv-status-'+row.overall_status.toLowerCase()">{{ (row.overall_status != 'PARTIALLY_PAID')? row.overall_status : row.overall_status.replace('_', ' ') }}</span>
        </template>
      </table-column>
      <table-column
        :label="$t('invoices.number')"
        show="invoice_number"
      />
      <table-column
        v-if="userType!='funder'"
        :label="$t('deliveryNotes.delivery_note_number')"
        show="delivery_note.delivery_note_number"
      />
      <table-column
        :label="$t('invoices.nominal_amount')"
        sort-as="total"
      >
        <template slot-scope="row">
          <span>{{ $t('invoices.total') }}</span>
          <div v-html="$utils.formatMoney(row.nominal_amount, row.customer.currency)"/>

        </template>
      </table-column>

      <table-column
        :label="$t('general.cashflow_value')"
        sort-as="total"
      >
        <template slot-scope="row">
          <span>{{ $t('invoices.total') }}</span>
          <div v-if="row.invoice_approved"
               v-html="$utils.formatMoney(row.total, row.customer.currency)"/>

        </template>
      </table-column>

      <table-column
        :label="$t('invoices.prePayment')"
      >
        <template slot-scope="row">
          <span> {{ $t('invoices.prePayment') }}</span>
          <span v-if="row.request_level=='Pending' && row.funder_invoices.user" :class="'inv-status-'+row.request_level.toLowerCase()"> {{ row.request_level }}-{{ row.funder_invoices.user.name }}</span>
          <span v-else-if="userType=='anchor' && row.request_level=='Eligible'" :class="'inv-status-'+row.request_level.toLowerCase()">No Request</span>
          <span v-else-if="userType=='anchor' && row.request_level=='Requested' " :class="'inv-status-'+row.request_level.toLowerCase()">Supplier Create Request</span>
          <span v-else-if="userType=='anchor' && row.request_level=='Verified'" :class="'inv-status-'+row.request_level.toLowerCase()"> {{ $t('general.Requested') }}</span>
          <span v-else-if="row.request_level=='Financed'" :class="'inv-status-'+row.request_level.toLowerCase()">{{ $t('general.financing_approved') }}</span>
          <span v-else :class="'inv-status-'+row.request_level.toLowerCase()"> {{ row.request_level }}</span>
        </template>
      </table-column>
    </table-component>
    <div v-if="userType=='supplier'">
      <div v-if="fetchData[0] && fetchData[0].non_fianance_invoice_info" class="payment-card card">
        <div class="card-body">
          <div class="row">
            <label class="form-label">{{ $t('payments.schedule_payment_date') }}
              <span v-if="fetchData[0] && fetchData[0].non_fianance_invoice_info">
                {{ fetchData[0].non_fianance_invoice_info.formattedSchedulePaymentDate }}
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    fetchData: { default: () => [], type: [Array, Function, Object] },
    tableDivId: {default: '', type: String }
  },
  created () {
    if (localStorage.getItem('account_type') == 'funder' || localStorage.getItem('role') == 'super_admin' || localStorage.getItem('account_type') == 'anchor') {
      this.advanceOption = false
    } else {
      this.advanceOption = true
    }
    if (localStorage.getItem('role') == 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') == 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') == 'supplier') {
      this.userType = 'supplier'
    } else if (localStorage.getItem('account_type') == 'funder') {
      this.userType = 'funder'
    }
  },
  methods: {
    tenor (due_date) {
      let daysInNumber = parseInt((new Date(Date()) - new Date(due_date)) / (1000 * 60 * 60 * 24), 10)
      let daypro
      if (daysInNumber > 1 || daysInNumber < 0) {
        daypro = 'Days'
      } else if (daysInNumber == 1) {
        daypro = 'Day'
      }
      if (Math.sign(daysInNumber) == 1) {
        return daysInNumber + ' ' + daypro + ' Over'
      } else if (Math.sign(daysInNumber) == -1) {
        return daysInNumber + ' ' + daypro + ' Left'
      } else if (Math.sign(daysInNumber) == 0) {
        return 'Last Day'
      } else {
        return 'error'
      }
    },
    nomailAmount (row) {
      let subTotal = row.sub_total
      let nomailAmount = 0
      let taxes = null
      if (row.taxes) {
        taxes = row.taxes.filter(function (obj) {
          return obj.operator !== 'Subtract'
        })

        if (taxes.length > 0) {
          nomailAmount = subTotal + taxes.map(o => o.amount).reduce((a, c) => { return a + c })
        } else {
          nomailAmount = row.sub_total
        }
      }
      return nomailAmount
    }
  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px !important;
}
</style>
